import { NgModule } from '@angular/core';

import { MenubarModule } from 'primeng/menubar';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TabMenuModule } from 'primeng/tabmenu';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { SliderModule } from 'primeng/slider';
import { TabViewModule  } from 'primeng/tabview';
import { AccordionModule } from 'primeng/accordion';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';

@NgModule({
  declarations: [
  ],
  imports: [
    MenubarModule,
    InputTextModule,
    ButtonModule,
    TabMenuModule,
    CardModule,
    TableModule,
    FileUploadModule,
    DialogModule,
    DropdownModule,
    CalendarModule,
    ProgressSpinnerModule,
    ToastModule,
    TooltipModule,
    SelectButtonModule,
    MultiSelectModule,
    AutoCompleteModule,
    CheckboxModule,
    SliderModule,
    TabViewModule,
    AccordionModule,
    OverlayPanelModule,
    RadioButtonModule,
  ],
  exports: [
    MenubarModule,
    InputTextModule,
    ButtonModule,
    TabMenuModule,
    CardModule,
    TableModule,
    FileUploadModule,
    DialogModule,
    DropdownModule,
    CalendarModule,
    ProgressSpinnerModule,
    ToastModule,
    TooltipModule,
    SelectButtonModule,
    MultiSelectModule,
    AutoCompleteModule,
    CheckboxModule,
    SliderModule,
    TabViewModule,
    AccordionModule,
    OverlayPanelModule,
    RadioButtonModule,
  ],
  providers: [
    MessageService
  ],
  bootstrap: []
})
export class PrimengComponentsModule { }